import { RevealText } from "@/components/shared/RevealText";
import { CTAButton } from "@/components/shared/CTAButton";
import { AnimatedSection } from "@/components/shared/AnimatedSection";

const IMAGE =
  "https://images.unsplash.com/photo-1725131481715-f0aa4357665d?crop=entropy&cs=srgb&fm=jpg&q=80&w=1200";

export const TeacherCTA = () => (
  <section className="py-24 px-6 bg-cream">
    <div className="max-w-7xl mx-auto grid lg:grid-cols-2 gap-12 items-center">
      <AnimatedSection>
        <img
          src={IMAGE}
          alt="Teacher exploring new career opportunities"
          className="rounded-2xl w-full h-[380px] object-cover shadow-lg"
        />
      </AnimatedSection>
      <AnimatedSection delay={0.15}>
        <RevealText
          as="h2"
          text="Looking for Your Next Teaching Opportunity?"
          className="font-heading text-3xl sm:text-4xl font-semibold text-navy tracking-tight leading-tight"
        />
        <p className="mt-5 text-slate text-base leading-relaxed max-w-md">
          Connect with Mithra Jobs and explore opportunities that match your teaching experience and career goals.
        </p>
        <div className="mt-8">
          <CTAButton to="/contact-us#enquiry" variant="primary" testId="teacher-cta-submit-profile">
            Submit Your Profile
          </CTAButton>
        </div>
      </AnimatedSection>
    </div>
  </section>
);
